import styled from 'styled-components'
import { codGray, lightGray, white } from 'tcp-common/lib/colors'
import Flex from 'tcp-common/lib/components/Flex'

export const MainWrapper = styled(Flex)`
background-color: ${codGray};
justify-content:center;
@media (min-width: 768px) {
    margin: 0 auto; 
}
`
export const MainContent = styled(Flex)`
padding: 44px 16px 80px;
justify-content:center;
@media (max-width: 768px) {
    margin: 16px;
    max-width:1024px;
    overflow-y: scroll;
}
`
export const Header = styled.h2`
font-weight: 700;
font-size: 24px;
line-height: 32px;
color: ${lightGray};
max-width:1024px;
@media (max-width: 768px) {
    font-size: 20px;
    line-height: 24px;
    margin: 16px;
}
`
export const SubHeader = styled.p`
font-weight: 400;
font-size: 16px;
line-height: 19px;
max-width:1024px;
color: ${lightGray};
@media (max-width: 768px) {
    font-size: 14px;
    line-height: 17px;
    margin: 0 16px 16px;
}
`
export const SubHeader1 = styled.h3`
font-weight: 400;
font-size: 16px;
line-height: 19px;
max-width:1024px;
color: ${lightGray};
text-decoration: underline;
@media (max-width: 768px) {
    font-size: 14px;
    line-height: 17px;
    margin: 0 16px 16px;
}
`
export const TermsButton = styled.button`
background: ${codGray};
height: 40px;
border: none;
text-align: center;
font-size: 14px;
line-height: 17px;
color: ${white};
cursor: pointer;
outline: none;
width: 100%;
&:focus {
  outline: none;
}
margin-top: 16px;
margin-bottom: 17px;
position: relative;
text-decoration: underline;
`
export const CloseModal = styled.img`
  position: sticky;
  right: 30px;
  float: right;
  cursor: pointer;
  @media (min-width: 768px) {
    top: 38px;
  }
  @media (max-width: 768px) {
    right: 16px;
  }
`
export const WrapperDiv = styled.div`
  height: auto;
  padding: 0 0 24px;
  position: relative;
`
export const SubHeaderView = styled.div``